import React from 'react'
import { Spinner, SpinnerProps } from 'reactstrap'

export const Loader = (props: SpinnerProps) => {
    return <Spinner {...props}> </Spinner>
}
